import type storeZh from '../zh/store';

const store: typeof storeZh = {
  title: 'Ủy quyền cửa hàng',
  market: 'Thị trường',
  store_type: 'Loại cửa hàng',
  all: 'Tất cả',
  market_vn: 'Việt Nam',
  market_th: 'Thái Lan',
  market_id: 'Indonesia',
  market_my: 'Malaysia',
  market_ph: 'Philippines',
  market_sg: 'Singapore',
  type_cross: 'Cửa hàng xuyên biên giới',
  type_local: 'Cửa hàng nội địa',
  shop_local: 'Nội địa',
  shop_cross: 'Xuyên biên giới',
  authorized: 'Đã ủy quyền',
  store_code: 'Mã cửa hàng',
  seller_email: 'Email người bán',
  authorized_at: 'Thời gian ủy quyền',
  can_send: 'Có thể gửi ',
  channel_dm: 'tin nhắn',
  can_send_mid: ', ',
  channel_email: 'email',
  can_send_end: ', và tạo ',
  targeted_invite: 'lời mời định hướng',
  unbind: 'Hủy liên kết',
  unbind_title: 'Xác nhận hủy liên kết cửa hàng',
  unbind_confirm: 'Xác nhận hủy liên kết',
  unbind_desc:
    'Sẽ giải phóng 1 suất và thu hồi token. Tin nhắn của cửa hàng này tạm dừng, lời mời định hướng đang chạy sẽ ngừng đồng bộ.',
  empty_slot: 'Suất trống',
  sea_only: 'Chỉ thị trường Đông Nam Á mới được ủy quyền',
  authorize_new: 'Ủy quyền cửa hàng mới',
  purchase_slot: 'Mua suất',
  authorize_title: 'Ủy quyền cửa hàng TikTok',
  go_authorize: 'Ủy quyền ngay',
  authorize_desc:
    'Bạn sẽ được chuyển tới trang ủy quyền chính thức của TikTok. Khi thành công sẽ chiếm 1 suất trống. Không lưu mật khẩu cửa hàng.',
  auth_market: 'Thị trường ủy quyền',
  auth_market_placeholder: 'Chọn thị trường Đông Nam Á',
  auth_market_hint: 'Hiện chỉ hỗ trợ ủy quyền cửa hàng tại Đông Nam Á',
  authorize_redirect: 'Sắp chuyển tới ủy quyền cửa hàng {{market}}',
  authorize_failed: 'Không lấy được liên kết ủy quyền',
  unbind_success: 'Đã hủy liên kết: {{name}}',
  unbind_failed: 'Không hủy liên kết được cửa hàng',
  add_auth: 'Thêm ủy quyền',
  safety_hint: 'Không lưu mật khẩu cửa hàng · Hủy liên kết sẽ giải phóng suất',
  load_failed: 'Không tải được danh sách cửa hàng'
};

export default store;
